<template>
  <div class="stat-container">
    <VisitLog />
    <ValueSub />
    <ValueUse />
    <!-- <CompanyOrder /> -->
  </div>
</template>

<script setup>
  import VisitLog from './components/visitlog'
  import ValueSub from './components/valuesub'
  import ValueUse from './components/valueuse'
  // import CompanyOrder from './components/companyorder'
</script>

<style lang="less">
@import "index.less";
</style>
